import React from 'react';
import { Link } from 'react-router-dom';

import logo from '../assets/images/logo/logo.png';
import cursor from '../assets/images/icons/cursor.svg';
import { nav } from '../utils/utils';

const MainBoard = () => {
    return (
        <div className='flex flex-wrap h-screen items-center  '>
            <div className='m-auto p:2 py-4 md:p-8 border-4 border-red-900 rounded-tr-[100px] rounded-bl-[100px] rounded-br-xl rounded-tl-xl text-3xl underline text-white'>
                <img
                    className='object-center scale-[.8] md:scale-100 mx-auto'
                    src={logo}
                    alt=''
                />

                <ul className='mx-auto text-center max-w-[240px] md:max-w-none'>
                    {nav.map((item, idx) => {
                        return (
                            <li className='relative group m-2 px-4 md:px-8 py-1' key={idx}>
                                <img
                                    className='absolute my-2 left-0 rotate-90 inline scale-150 peer invisible group-hover:visible'
                                    src={cursor}
                                    alt=''
                                />
                                <Link to={item.to} className='ml-2 '>
                                    {item.name}
                                </Link>
                            </li>
                        );
                    })}
                </ul>
            </div>
        </div>
    );
};

export default MainBoard;
